import ICustomerBase from "./ICustomerBase";

export default class CustomerBase implements ICustomerBase {
    constructor(public phone?: string, public email?: string, public firstName?: string, public lastName?: string) {}
}
